export default "__VITE_ASSET__C90AABS2__"